import { z } from 'zod';

export const createRegisterSchema = () =>
  z
    .object({
      firstname: z.string().optional(),
      lastname: z.string().optional(),

      username: z
        .string()
        .min(1, 'Username cannot be empty')
        .min(3, 'Username must be at least 3 characters')
        .refine((value) => /[A-Za-z]/.test(value), {
          message: 'Username must contain at least one alphabetic character',
        }),

      phone: z.string().min(8, 'Enter a valid mobile number'),

      otp: z.string().regex(/^\d{6}$/, 'Enter the 6-digit OTP sent to your mobile'),

      password: z
        .string()
        .min(1, 'password cannot be empty')
        .min(6, 'Minimum 6 characters required')
        .regex(/^[a-zA-Z0-9]+$/, 'Password can only contain letters and numbers (no special characters)'),

      confirmPassword: z.string().min(1, 'please confirm your password'),

      referralCode: z.string().optional(),
    })
    .refine((data) => data.password === data.confirmPassword, {
      message: 'Passwords do not match',
      path: ['confirmPassword'],
    });

export type RegisterFormValues = z.infer<ReturnType<typeof createRegisterSchema>>;
